export default __webpack_public_path__ + "static/media/desk_preland_8.ebcc0cbc.jpg";